import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Typography } from 'antd';
import type { FC } from 'react';
import { KeyCap } from './Hotkeys';

export interface KeyHint {
  keys: Array<string>;
  label: string;
}

interface Props {
  hints: Array<KeyHint>;
  fallback?: string;
}

/** Bar naming the keys usable right now. Sits at the bottom of the component it documents. */
export const KeyHintsFooter: FC<Props> = ({ hints, fallback }) => (
  // Height is fixed even with nothing to show, so the content above never resizes when the
  // usable keys change.
  <Footer>
    {hints.length === 0
      ? fallback != null && <Label type="secondary">{fallback}</Label>
      : hints.map(({ keys, label }) => (
          <Hint key={label}>
            {keys.map((key) => (
              <KeyCap key={key}>{key}</KeyCap>
            ))}
            <Label type="secondary">{label}</Label>
          </Hint>
        ))}
  </Footer>
);

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 24px;
  min-height: 24px;
  max-height: 24px;
  padding: 0 8px;
  border-top: solid 1px ${RacemapColors.LightGray};
`;

const Hint = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

const Label = styled(Typography.Text)`
  font-size: 11px;
`;
